(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omni-illustrated-cart"]) return;
  try {
    
document.addEventListener('click', async function(event) {
  const link = event.target.closest('[data-art-remove]');
  if (!link) return;
  event.preventDefault();
  link.setAttribute('aria-disabled', 'true');
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:Number(link.dataset.line),quantity:0})});
    if (!response.ok) throw new Error('Cart update failed');
    window.location.assign(window.Shopify.routes.root + 'cart?view=illustrated');
  } catch (error) { window.location.assign(link.href); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omni-shell"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.omniStoreInitialized) return;
  const configNode = document.querySelector('[data-omni-config]');
  if (!configNode) return;
  window.omniStoreInitialized = true;
  const config = JSON.parse(configNode.textContent);
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const t = (key, values = {}) => String(config.text[key] ?? key).replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name) => String(values[name] ?? ''));
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:config.currency}).format(Number(cents || 0) / 100);
  const parseData = (node, fallback = null) => { try { return node ? JSON.parse(node.textContent) : fallback; } catch { return fallback; } };
  const catalogCache = new Map();
  const productData = new WeakMap();
  let collectionState, cartState, cartBusy = false, searchTimer, searchRequest = 0, productRequest = 0, toastTimer;
  const focusReturn = new WeakMap();
  const textStatus = message => {
    const toast = $('#toast');
    if (!toast) return;
    toast.textContent = message; toast.classList.add('visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => toast.classList.remove('visible'), 4500);
  };
  async function request(url, options = {}) {
    const response = await fetch(url, {credentials:'same-origin', ...options, headers:{Accept:'application/json', ...options.headers}});
    let data;
    try { data = await response.json(); } catch { throw new Error(t('connection_error')); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : t('connection_error'));
    return data;
  }
  async function sectionHTML(path, section, extra = {}) {
    const url = new URL(path, location.origin);
    url.searchParams.set('section_id', section);
    for (const [name, value] of Object.entries(extra)) url.searchParams.set(name, value);
    const previewId = new URL(location.href).searchParams.get('preview_theme_id');
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    const response = await fetch(url, {credentials:'same-origin'});
    if (!response.ok) throw new Error(t('connection_error'));
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  }
  function openDialog(dialog, opener = document.activeElement) {
    if (!dialog) return;
    $$('.omni-store dialog[open]').forEach(open => { if (open !== dialog) open.close(); });
    focusReturn.set(dialog, opener);
    if (!dialog.open) dialog.showModal();
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    dialog.close();
    const previous = focusReturn.get(dialog);
    if (previous?.isConnected && !previous.closest('dialog:not([open])')) previous.focus({preventScroll:true});
    else $('.wordmark')?.focus({preventScroll:true});
  }
  async function catalogFor(url) {
    if (catalogCache.has(url)) return catalogCache.get(url);
    const promise = (async () => {
      const items = [], seen = new Set();
      for (let page = 1, pages = 1; page <= pages; page++) {
        const doc = await sectionHTML(url, 'omni-catalog-data', {page});
        const data = parseData($('[data-omni-catalog]', doc));
        if (!data || !Array.isArray(data.products)) throw new Error(t('connection_error'));
        pages = Math.max(1, Number(data.pages));
        for (const product of data.products) if (!seen.has(product.id)) { seen.add(product.id); items.push(product); }
      }
      return items;
    })();
    catalogCache.set(url, promise);
    promise.catch(() => catalogCache.delete(url));
    return promise;
  }
  function card(product, index) {
    const photo = product.images?.[0], alternate = product.images?.[1];
    const title = `${product.state} ${t('edition')}`;
    const images = photo ? `<img src="${esc(photo.src)}" alt="${esc(photo.alt)}" loading="${index < 4 ? 'eager' : 'lazy'}" width="700" height="875">${alternate ? `<img class="alternate" src="${esc(alternate.src)}" alt="${esc(alternate.alt)}" loading="lazy" width="700" height="875">` : ''}` : '';
    const colors = (product.colors || []).map(color => `<span class="color-dot" title="${esc(color)}" style="background:${color.toLowerCase() === 'black' ? '#20201e' : color.toLowerCase() === 'white' ? '#fafafa' : '#a6a6a4'}"></span>`).join('');
    return `<article class="product-card"><div class="product-photo"><a href="${esc(product.url)}" data-product="${esc(product.handle)}" aria-label="${esc(product.title)}">${images}</a><span class="product-label">${esc(t('series'))}</span><button class="quick-add" data-product="${esc(product.handle)}" aria-label="${esc(t('choose_for',{title:product.title}))}"><span>${esc(t('choose'))}</span><b aria-hidden="true">+</b></button></div><div class="product-info"><div><h3><a href="${esc(product.url)}" data-product="${esc(product.handle)}">${esc(title)}</a></h3><p>${esc(t(product.type === 'Hoodie' ? 'hoodie' : 'tee'))}</p></div><span class="product-price">${esc(product.priceText || money(product.price))}</span></div><div class="product-colors" aria-label="${esc(t('available_colors'))}">${colors}</div></article>`;
  }
  function renderCollection() {
    const state = collectionState;
    if (!state?.node.isConnected) return;
    const list = state.items.filter(p => (state.type === 'all' || p.type === state.type) && (state.state === 'all' || p.state === state.state));
    const grid = $('#products', state.node);
    grid.innerHTML = list.slice(0, state.visible).map(card).join('');
    $('#result-count', state.node).textContent = t('result_count',{shown:Math.min(state.visible,list.length),total:list.length}) + (state.state !== 'all' ? ' · ' + state.state : '');
    $('#load-more', state.node).hidden = state.visible >= list.length;
    $('#clear-filters', state.node).hidden = state.type === 'all' && state.state === 'all';
    $$('.filter', state.node).forEach(button => { const selected = button.dataset.filter === state.type; button.classList.toggle('selected',selected); button.setAttribute('aria-pressed',String(selected)); });
  }
  function initializeCollection() {
    const node = $('[data-omni-collection]');
    if (!node || collectionState?.node === node) return;
    const initial = parseData($('[data-omni-initial]',node), []);
    const priority = parseData($('[data-omni-priority]',node), []);
    const total = Number(node.dataset.total);
    collectionState = {node,items:initial,visible:8,type:'all',state:'all',ready:false};
    $('#result-count', node).textContent = t('result_count',{shown:Math.min(8,initial.length),total});
    const ownState = collectionState;
    ownState.promise = catalogFor(node.dataset.collectionUrl).then(items => {
      if (collectionState !== ownState) return;
      const priorities = new Map(priority.map((handle,index) => [handle,index]));
      items.sort((a,b) => (priorities.get(a.handle) ?? 1000) - (priorities.get(b.handle) ?? 1000) || a.title.localeCompare(b.title));
      ownState.items = items; ownState.ready = true;
      $('[data-filter="all"] span',node).textContent = items.length;
      if (ownState.type !== 'all' || ownState.state !== 'all' || ownState.visible > 8) renderCollection();
      $('#load-more',node).hidden = items.length <= 8;
    }).catch(error => {
      const message = $('[data-collection-error]',node); message.textContent = error.message; message.hidden = false;
    });
  }
  async function changeCollection(action) {
    const state = collectionState;
    if (!state) return;
    action(state);
    state.node.setAttribute('aria-busy','true');
    await state.promise;
    state.node.removeAttribute('aria-busy');
    if (!state.ready) { textStatus(t('connection_error')); return; }
    renderCollection();
  }
  const normalizeColor = value => String(value || '').toLowerCase().replace(/athletic heather|heather grey|heather gray/g,'heather').trim();
  function selectedVariant(state) { return state.data.product.variants.find(v => v.option1 === state.color && v.option2 === state.size); }
  function updateProduct(node) {
    const state = productData.get(node);
    if (!state) return;
    const variant = selectedVariant(state);
    $$('[data-color]',node).forEach(button => { const selected = button.dataset.color === state.color; button.classList.toggle('selected',selected); button.setAttribute('aria-pressed',String(selected)); });
    $$('[data-size]',node).forEach(button => { const v = state.data.product.variants.find(item => item.option1 === state.color && item.option2 === button.dataset.size); button.disabled = !v?.available; button.classList.toggle('selected',button.dataset.size === state.size); button.setAttribute('aria-pressed',String(button.dataset.size === state.size)); });
    $$('[data-view]',node).forEach(button => { const selected = button.dataset.view === state.view; button.classList.toggle('selected',selected); button.setAttribute('aria-pressed',String(selected)); });
    $('[data-color-label]',node).textContent = t('color_label',{color:state.color});
    $('[data-size-label]',node).textContent = state.size ? t('size_label',{size:state.size}) : t('size_prompt');
    const price = $('[data-price]',node);
    price.textContent = money(variant?.price ?? state.data.product.price);
    const add = $('[data-add]',node);
    add.disabled = !variant?.available || state.busy;
    $('[data-add-label]',node).textContent = state.busy ? t('adding') : !state.size ? t('select_size') : variant?.available ? t('add_bag') : t('sold_out');
    const input = $('[name="id"]',node);
    if (variant) input.value = String(variant.id);
    const fullLink = $('[data-full-details]',node);
    if (fullLink) fullLink.href = root + 'products/' + state.data.product.handle + (variant ? '?variant=' + variant.id : '');
    const desiredColor = normalizeColor(state.color);
    const viewPattern = new RegExp('\\b' + state.view + '\\b', 'i');
    const matching = state.data.images.find(image => normalizeColor(image.alt).includes(desiredColor) && viewPattern.test(image.alt));
    const fallback = variant?.featured_image ? state.data.images.find(image => image.id === variant.featured_image.id) : null;
    const image = matching || fallback;
    const picture = $('[data-product-image]',node);
    const missing = $('[data-image-unavailable]',node);
    if (image) { picture.src = image.src; picture.removeAttribute('srcset'); picture.alt = image.alt || state.data.product.title; missing.hidden = true; }
    else { missing.textContent = t('image_unavailable',{color:state.color}); missing.hidden = false; }
  }
  function initializeProduct(node) {
    if (productData.has(node)) return;
    const data = parseData($('[data-product-data]',node));
    if (!data?.product?.variants?.length) return;
    const variant = data.product.variants.find(v => String(v.id) === node.dataset.selectedVariant) || data.product.variants.find(v => v.available) || data.product.variants[0];
    productData.set(node,{data,color:variant.option1,size:node.dataset.deepLink === 'true' ? variant.option2 : null,view:'back',busy:false});
    updateProduct(node);
  }
  async function showProduct(handle, opener) {
    const id = ++productRequest;
    const dialog = $('#product-dialog'), holder = $('#product-detail');
    holder.innerHTML = `<p class="omni-loading" role="status">${esc(t('loading_product'))}</p>`;
    openDialog(dialog,opener);
    try {
      const doc = await sectionHTML(root + 'products/' + encodeURIComponent(handle),'omni-product');
      const product = $('[data-omni-product]',doc);
      if (!product) throw new Error(t('product_unavailable'));
      if (id !== productRequest) return;
      product.classList.remove('omni-product-page');
      holder.replaceChildren(product);
      initializeProduct(product);
    } catch (error) {
      if (id !== productRequest) return;
      holder.innerHTML = `<div class="omni-loading"><p role="status">${esc(error.message)}</p><a class="text-link" href="${root}products/${encodeURIComponent(handle)}">${esc(t('full_details'))} ↗</a></div>`;
    }
  }
  async function addProduct(node) {
    const state = productData.get(node), variant = state && selectedVariant(state);
    if (!variant?.available || state.busy || cartBusy) return;
    state.busy = true; cartBusy = true; updateProduct(node);
    const errorNode = $('[data-product-error]',node); errorNode.hidden = true;
    try {
      await request(root + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});
      await refreshCart();
      openDialog($('#bag-dialog'),$('#bag-open'));
    } catch (error) { errorNode.textContent = error.message; errorNode.hidden = false; }
    finally { cartBusy = false; state.busy = false; updateProduct(node); renderCart(); }
  }
  function cartItems(cart) {
    if (!cart.item_count) return `<div class="empty-bag"><h3>${esc(t('empty_title'))}</h3><p>${esc(t('empty_copy'))}</p><a class="button button-dark" href="${root}#collection" data-bag-shop>${esc(t('explore'))}<span aria-hidden="true">↗</span></a></div>`;
    return cart.items.map(item => {
      const image = item.featured_image?.url || item.image;
      const options = (item.options_with_values || []).map(option => option.value).join(' / ');
      const discount = (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application?.title).filter(Boolean).join(', ');
      return `<article class="bag-item">${image ? `<img src="${esc(image)}" alt="${esc(item.featured_image?.alt || item.product_title)}" width="85" height="106">` : '<div></div>'}<div><h3><a href="${esc(item.url)}">${esc(item.product_title)}</a></h3><p>${esc(options)} · ${money(item.final_price)}</p>${discount ? `<p class="omni-discount">${esc(discount)}</p>` : ''}<div class="bag-item-bottom"><div class="quantity-control"><button type="button" data-cart-key="${esc(item.key)}" data-change="-1" aria-label="${esc(t('decrease',{title:item.product_title}))}" ${cartBusy ? 'disabled' : ''}>−</button><span>${item.quantity}</span><button type="button" data-cart-key="${esc(item.key)}" data-change="1" aria-label="${esc(t('increase',{title:item.product_title}))}" ${cartBusy ? 'disabled' : ''}>+</button></div><button type="button" class="remove-item" data-remove-key="${esc(item.key)}" aria-label="${esc(t('remove_product',{title:item.product_title}))}" ${cartBusy ? 'disabled' : ''}>${esc(t('remove'))}</button></div><p class="omni-line-price">${item.original_line_price > item.final_line_price ? `<s>${money(item.original_line_price)}</s>` : ''}${money(item.final_line_price)}</p></div></article>`;
    }).join('');
  }
  function cartSummary(cart) {
    if (!cart.item_count) return '';
    const discounts = (cart.cart_level_discount_applications || []).map(discount => `<p class="omni-discount">${esc(discount.title)} −${money(discount.total_allocated_amount)}</p>`).join('');
    return `${discounts}<div class="bag-subtotal"><span>${esc(t('subtotal'))}</span><span>${money(cart.total_price)} ${esc(cart.currency)}</span></div><p class="bag-small">${esc(t('checkout_note'))}</p><form action="${esc(config.cartUrl)}" method="post"><button class="button button-dark bag-checkout" type="submit" name="checkout" ${cartBusy ? 'disabled' : ''}>${esc(t('checkout'))}<span aria-hidden="true">↗</span></button></form>`;
  }
  function renderCart() {
    if (!cartState) return;
    config.currency = cartState.currency || config.currency;
    $('#bag-count').textContent = cartState.item_count;
    $('#drawer-count').textContent = '(' + cartState.item_count + ')';
    $('#bag-open').setAttribute('aria-label',t('bag_count',{count:cartState.item_count}));
    $$('[data-cart-items]').forEach(node => { node.innerHTML = cartItems(cartState); node.setAttribute('aria-busy',String(cartBusy)); });
    $$('[data-cart-summary]').forEach(node => node.innerHTML = cartSummary(cartState));
  }
  async function refreshCart() { cartState = await request(root + 'cart.js'); renderCart(); return cartState; }
  async function changeCart(key, delta, remove = false) {
    if (cartBusy || !cartState) return;
    const item = cartState.items.find(line => line.key === key);
    if (!item) return;
    cartBusy = true; renderCart();
    try {
      cartState = await request(root + 'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:remove ? 0 : Math.max(0,item.quantity + delta)})});
    } catch (error) { textStatus(error.message); try { await refreshCart(); } catch {} }
    finally { cartBusy = false; renderCart(); }
  }
  async function runSearch() {
    const input = $('#search-input'), resultsNode = $('#search-results');
    const value = input.value.trim(), id = ++searchRequest;
    if (!value) { resultsNode.innerHTML = `<p class="search-hint">${esc(t('search_hint'))}</p>`; return; }
    resultsNode.innerHTML = `<p class="search-hint">${esc(t('searching'))}</p>`;
    try {
      const items = await catalogFor(config.allCollectionUrl);
      const query = value.toLowerCase().replace(/t-shirts?|tshirts?/g,'tee');
      const exactState = items.find(item => item.state.toLowerCase() === query)?.state;
      let results = items.filter(item => exactState ? item.state === exactState : (item.title + ' ' + (item.type === 'T-Shirt' ? 'tee tshirt' : 'hoodie')).toLowerCase().replace(/t-shirts?/g,'tee').includes(query));
      if (!results.length) {
        const params = new URLSearchParams({q:value,'resources[type]':'product','resources[limit]':'8'});
        const suggestions = await request(root + 'search/suggest.json?' + params);
        const handles = new Set((suggestions.resources?.results?.products || []).map(item => item.handle));
        results = items.filter(item => handles.has(item.handle));
      }
      if (id !== searchRequest) return;
      const resultHTML = results.slice(0,8).map(item => `<button class="search-result" data-product="${esc(item.handle)}">${item.images?.[0] ? `<img src="${esc(item.images[0].src)}" alt="${esc(item.images[0].alt)}" width="65" height="74">` : ''}<div><strong>${esc(item.state)} ${esc(t('edition'))}</strong><p>${esc(item.type)}</p></div><span>${esc(item.priceText || money(item.price))}</span></button>`).join('');
      resultsNode.innerHTML = `<p class="search-hint">${esc(results.length ? t('search_found',{count:results.length}) : t('search_empty'))}</p>${resultHTML}<a class="omni-all-results" href="${root}search?type=product&q=${encodeURIComponent(value)}">${esc(t('view_all_results'))} ↗</a>`;
    } catch (error) { if (id === searchRequest) resultsNode.innerHTML = `<p class="search-hint" role="status">${esc(error.message)}</p>`; }
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('button,a');
    if (!target) return;
    if (target.matches('[data-product]') && !event.metaKey && !event.ctrlKey && !event.shiftKey) { event.preventDefault(); showProduct(target.dataset.product,target); return; }
    if (target.matches('.close-dialog')) { closeDialog(target.closest('dialog')); return; }
    if (target.id === 'search-open') { openDialog($('#search-dialog'),target); $('#search-input').focus(); runSearch(); return; }
    if (target.id === 'bag-open') { openDialog($('#bag-dialog'),target); refreshCart().catch(error => textStatus(error.message)); return; }
    if (target.matches('[data-newsletter-open]')) { event.preventDefault(); openDialog($('#newsletter-dialog'),target); return; }
    if (target.dataset.filter) { changeCollection(state => { state.type = target.dataset.filter; state.visible = 8; }); return; }
    if (target.id === 'clear-filters') { $('#state-filter').value = 'all'; changeCollection(state => { state.type = 'all'; state.state = 'all'; state.visible = 8; }); return; }
    if (target.id === 'load-more') { const index = collectionState.visible; changeCollection(state => state.visible += 8).then(() => $('#products')?.children[index]?.querySelector('a')?.focus({preventScroll:true})); return; }
    if (target.matches('[data-color],[data-size],[data-view]')) {
      const node = target.closest('[data-omni-product]'), state = productData.get(node);
      if (!state) return;
      if (target.dataset.color) { state.color = target.dataset.color; if (!selectedVariant(state)?.available) state.size = null; }
      if (target.dataset.size) state.size = target.dataset.size;
      if (target.dataset.view) state.view = target.dataset.view;
      updateProduct(node); return;
    }
    if (target.dataset.cartKey) { changeCart(target.dataset.cartKey,Number(target.dataset.change)); return; }
    if (target.dataset.removeKey) { changeCart(target.dataset.removeKey,0,true); return; }
    if (target.hasAttribute('data-bag-shop')) { closeDialog($('#bag-dialog')); }
    if (target.id === 'menu-open') { const nav = $('#mobile-nav'); nav.hidden = !nav.hidden; target.setAttribute('aria-expanded',String(!nav.hidden)); return; }
    if (target.closest('#mobile-nav')) { $('#mobile-nav').hidden = true; $('#menu-open').setAttribute('aria-expanded','false'); }
    if (target.id === 'back-top') { event.preventDefault(); window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); $('.wordmark').focus({preventScroll:true}); }
  });
  document.addEventListener('change',event => { if (event.target.id === 'state-filter') changeCollection(state => { state.state = event.target.value; state.visible = 8; }); });
  document.addEventListener('input',event => { if (event.target.id === 'search-input') { clearTimeout(searchTimer); searchRequest++; searchTimer = setTimeout(runSearch,160); } });
  document.addEventListener('submit',event => { const node = event.target.closest('[data-omni-product]'); if (node && productData.has(node)) { event.preventDefault(); addProduct(node); } });
  document.addEventListener('keydown',event => { if (event.key === 'Escape') { $('#mobile-nav').hidden = true; $('#menu-open').setAttribute('aria-expanded','false'); } });
  function initialize() {
    document.documentElement.classList.add('omni-js');
    initializeCollection();
    $$('[data-omni-product]').forEach(initializeProduct);
    $$('dialog').forEach(dialog => {
      if (dialog.dataset.omniBound) return;
      dialog.dataset.omniBound = 'true';
      dialog.addEventListener('click',event => { const box = dialog.getBoundingClientRect(); if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) closeDialog(dialog); });
      dialog.addEventListener('cancel',event => { event.preventDefault(); closeDialog(dialog); });
    });
    if ($('[data-newsletter-status]')) openDialog($('#newsletter-dialog'),$('[data-newsletter-open]'));
  }
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('shopify:section:reorder',initialize);
  initialize();
  cartState = parseData($('[data-initial-cart]'));
  renderCart();
  refreshCart().catch(error => { if ($('[data-cart-page]')) textStatus(error.message); });
})();


  } catch(e) { console.error(e); }
})();
})();
